export function helpCenter() {
    $('body').on('click', '.help-center-tab a', function (e) {
        e.preventDefault();
        let item = $(this).closest('div');
        let target = $(this).attr("href");
        item.addClass('active').siblings().removeClass('active');
        $(".help-center-tab-info").removeClass("show");
        $(target).addClass("show");
    });


    $('.search-panel').on('keyup', 'input', function (e) {
        let input = $(this);
        let value = input.val().trim();

        $(e.delegateTarget)[(value.length > 2 ? 'add' : 'remove') + 'Class']('show-dropdowm');
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/help-center.js